import { Translate } from 'react-redux-i18n'
import TooltipExpression from '../../common/tooltipExpression'

export const TREND_RATIO_KEY = 'RT0020'

export const TREND_FUNDING_DATA = [
  {
    value: 'FA085',
    color: '#006AA6',
    isBarChart: true,
    tooltipContent: (
      <TooltipExpression
        style={{ alignItems: 'unset' }}
        expressions={[
          {
            text: <Translate value="financialAnalysis.SHORT_TERM_1" />,
            operator: '=',
            styleContainer: { alignItems: 'unset' },
          },
          {
            text: (
              <>
                <Translate value="financialAnalysis.SHORT_TERM_2" />
                <br />
                +&nbsp;
                <Translate value="financialAnalysis.SHORT_TERM_3" />
                <br />
                +&nbsp;
                <Translate value="financialAnalysis.SHORT_TERM_4" />
                <br />
                +&nbsp;
                <Translate value="financialAnalysis.SHORT_TERM_5" />
                <br />
                +&nbsp;
                <Translate value="financialAnalysis.SHORT_TERM_6" />
              </>
            ),
            styleText: { textAlign: 'unset' },
            styleContainer: { alignItems: 'unset' },
          },
        ]}
      />
    ),
  },
  {
    value: 'FA086',
    color: '#B3CC85',
    isBarChart: true,
    tooltipContent: (
      <TooltipExpression
        style={{ alignItems: 'unset' }}
        expressions={[
          {
            text: <Translate value="financialAnalysis.LONG_TERM_1" />,
            operator: '=',
            styleContainer: { alignItems: 'unset' },
          },
          {
            text: (
              <>
                <Translate value="financialAnalysis.LONG_TERM_2" />
                <br />
                +&nbsp;
                <Translate value="financialAnalysis.LONG_TERM_3" />
                <br />
                +&nbsp;
                <Translate value="financialAnalysis.LONG_TERM_4" />
                <br />
                +&nbsp;
                <Translate value="financialAnalysis.LONG_TERM_5" />
                <br />
                +&nbsp;
                <Translate value="financialAnalysis.LONG_TERM_6" />
              </>
            ),
            styleText: { textAlign: 'unset' },
            styleContainer: { alignItems: 'unset' },
          },
        ]}
      />
    ),
  },
  {
    value: 'FA087',
    color: '#D96383',
    isLineChart: true,
    tooltipContent: (
      <TooltipExpression
        expressions={[
          {
            text: <Translate value="financialAnalysis.LONG_LIQUID_ASSET_1" />,
            operator: '=',
          },
          {
            text: <Translate value="financialAnalysis.LONG_LIQUID_ASSET_2" />,
          },
        ]}
      />
    ),
  },
  {
    value: 'FA088',
    color: '#F49966',
    isLineChart: true,
    tooltipContent: (
      <TooltipExpression
        expressions={[
          {
            text: <Translate value="financialAnalysis.SHORT_LIQUID_ASSET_1" />,
            operator: '=',
          },
          {
            text: <Translate value="financialAnalysis.SHORT_LIQUID_ASSET_2" />,
          },
        ]}
      />
    ),
  },
]
